angular
  .module('common.directives')
  .directive('edgeGeofenceReport', function () {
    return {
      scope: {
        edge: '=',
        eventSearch: '='
      },
      templateUrl:
        './templates/edgeGeofenceeReports.view.html?t=' + webpackHash,
      link: function ($scope, $element, attrs) {},
      controller: 'edgegeofenceReportsController'
    }
  })
